import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store'

import Envelope from '@/views/Envelope'
import PageError from '@/views/PageError'
import Download from '@/views/Download'
import EnvelopeComplete from '@/views/EnvelopeComplete'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/error',
      name: 'PageError',
      component: PageError,
      props: true,
      meta: {
        requiresAuth: false
      }
    },
    {
      path: '/preview/:envelopeFingerprint',
      name: 'Preview',
      component: Envelope,
      meta: {
        requiresAuth: false,
        requiresPreviewAuth: true
      }
    },
    {
      path: '/preview/:previewURL',
      name: 'OldPreview',
      meta: {
        requiresAuth: false
      },
      beforeEnter (from) {
        window.location = process.env.VUE_APP_SECONDARY_SIGNING_PAGE_URL + '/#' + from.fullPath
      }
    },
    {
      path: '/widget/:widgetCode',
      name: 'SignWidget',
      meta: {
        requiresAuth: false
      },
      component: Envelope
    },
    {
      path: '/:envelopeFingerprint/:signatureFingerprint',
      name: 'OldSign',
      meta: {
        requiresAuth: false
      },
      beforeEnter (from) {
        window.location = process.env.VUE_APP_SECONDARY_SIGNING_PAGE_URL + '/#' + from.fullPath
      }
    },
    {
      path: '/complete',
      name: 'EnvelopeComplete',
      props: true,
      meta: {
        requiresAuth: false
      },
      component: EnvelopeComplete
    },
    {
      path: '/download',
      name: 'Download',
      meta: {
        requiresAuth: true
      },
      component: Download
    },
    {
      path: '/',
      name: 'Sign',
      meta: {
        requiresAuth: true
      },
      component: Envelope
    },
    {
      path: '*',
      name: 'notFound',
      meta: {
        requiresAuth: false
      },
      beforeEnter (to, from, next) {
        next({ name: 'PageError', params: { errorMessage: 'Page not found', errorCode: 404 } })
      }
    }
  ]
})

router.beforeEach((to, from, next) => {
  if (to.hash.startsWith('#/') && to.path === '/') { // Handle paths beginning with /#/ gracefully
    next({ path: to.hash.substring(1) })
    return
  }

  if (!store.getters['auth/authAttempted'] && to.meta.requiresAuth) {
    const key = to.hash.substring(1) // TODO Handle malformed URLs properly
    store.dispatch('auth/AUTHENTICATE', key).then(() => { // TODO Handle errors properly
      next()
      window.history.replaceState(null, null, to.path) // Remove the key from the path, doesn't remove it from the history
    })
  } else if (!store.getters['auth/authAttempted'] && to.meta.requiresPreviewAuth) {
    const key = to.hash.substring(1) // TODO Handle malformed URLs properly
    store.dispatch('auth/AUTHENTICATE_PREVIEW', key).then(() => { // TODO Handle errors properly
      next()
      if (process.env.VUE_APP_ENV !== 'development') window.history.replaceState(null, null, to.path) // Remove the key from the path, doesn't remove it from the history
    })
  } else {
    next()
  }
})

export default router
